import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import '../../App.scss';
import './imported.scss';
import { useConnect } from "@stacks/connect-react";

const NavBar = ({ connect }) => {
	const [scrolled, setScrolled] = useState(false);

	const onScroll = () => {
		if (document.documentElement.scrollTop > 20) {
			setScrolled(true);
		} else {
			setScrolled(false);
		}
	};

	useEffect(() => {
		window.addEventListener('scroll', onScroll);
		return () => {
			window.removeEventListener('scroll', onScroll);
		}
	}, []);

	useEffect(() => {
		$("a").on('click', function (event) {

			// Make sure this.hash has a value before overriding default behavior
			if (this.hash !== "") {
				// Prevent default anchor click behavior
				event.preventDefault();

				// Store hash
				var hash = this.hash;

				// Using jQuery's animate() method to add smooth page scroll
				// The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
				$('html, body').animate({
					scrollTop: $(hash).offset().top
				}, 800, function () {

					// Add hash (#) to URL when done scrolling (default click behavior)
					window.location.hash = hash;
				});
			} // End if
		});
	}, []);

	return (
		<nav id="navbar" className={`navbar fixed-top navbar-expand-xl navbar-header navbar-mobile ${scrolled ? 'header-scrolled' : ''}`}>
			<div className="navbar-container container">
				<div className="navbar-brand">
					<a className="navbar-brand-logo" href="#top">
						<img src={process.env.PUBLIC_URL + '/derupt-logo-256.png'} width="59px" alt="" />
					</a>
					<div id="erupt">erupt</div>
				</div>
				<div className="navbar-toggler"
					type="button"
					data-toggle="collapse"
					data-target="#navbarNav"
					aria-controls="navbarNav"
					aria-expanded="false"
					aria-label="Toggle navigation">
					<button className="theme-btn" onClick={connect}>
						Connect Wallet
					</button>
				</div>

				<div className="collapse navbar-collapse justify-content-end" id="navbarNav">

					<ul className="navbar-nav menu-navbar-nav">
						{/* <li className="nav-item">
							<a className="nav-link" href="#featuresSection">
								<p className="nav-link-menu">Features</p>
							</a>
						</li>
						<li className="nav-item">
							<a className="nav-link" href="#componentsSection">
								<p className="nav-link-menu">Built with</p>
							</a>
						</li> */}
						<li className="nav-item">
							<a className="nav-link" href="https://docs.derupt.io" target="_blank" rel="noopener noreferrer">
								<p className="nav-link-menu">Docs</p>
							</a>
						</li>
						<li className="nav-item nav-item-btn">
							<button className="theme-btn" onClick={connect}>
								Connect Wallet
							</button>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	)
}

// const HeaderSection = () => {
//   return (
//     <>
//     <div id="header" className="header-section">
// 				<div className="container header-section-container">
// 					<div className="col-lg-6 col-md-12 header-section-content">
// 						<div className="header-title-section"> 
// 							<h1>Derupt</h1>
// 							<p>Disruptive Defi!</p>
// 						</div>
// 					</div>

// 					<div className="col-lg-6 col-md-12 header-img-section">
// 						<div className="header-img-card">
// 							<img src={process.env.PUBLIC_URL + '/derupt-orange.png'} alt="" />
// 						</div>
// 					</div>

// 				</div>
// 			</div>
//       <div id="headerSection"></div>	
//     </>
//   )
// }

const FeaturesSection = () => {
	return (
		<>
			<div id="featuresSection"></div>
			<div className="features-section">
				<div className="features-section-bg">
				</div>
				<div className="container features-section-container">
					<div className="col-md-12 features-title-block">
					</div>
					<div className="container features-details-container">
						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/01-Content-Feed.png"} alt="feed" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Content Feed</h3>
									<p>Powered by Smart Contracts</p>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/02-Monetization.png"} alt="" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Monetization</h3>
									<p>Permissionless Participation</p>
								</div>
							</div>
						</div>
						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/03-Profiles.png"} alt="profiles" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Profiles</h3>
									<p>BNS & NFTs Supported</p>
								</div>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/04-Creating-Content.png"} alt="Creating" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Creating Content</h3>
									<p>Mine new CryptoCash</p>
								</div>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/05-Liking-Content.png"} alt="Liking" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Liking Content</h3>
									<p>Transfer CryptoCash to Authors</p>
								</div>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/06-Disliking-Content.png"} alt="Disliking" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Disliking Content</h3>
									<p>Stack CryptoCash to Earn STX</p>
								</div>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/07-Favorable-Replies.png"} alt="Favorable" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Favorable Replies</h3>
									<p>Mine new CryptoCash</p>
									<p>and</p>
									<p>Transfer CryptoCash to Authors</p>
								</div>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/08-Unfavorable-Replies.png"} alt="Unfavorable" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Unfavorable Replies</h3>
									<p>Mine new CryptoCash</p>
									<p>and</p>
									<p>Stack CryptoCash to Earn STX</p>
								</div>
							</div>
						</div>

						<div className="col-lg-4 col-md-6 col-sm-6 col-xs-12 features-details-card-section">
							<div className="features-details-card">
								<div className="features-details-card-img-section">
									<img src={process.env.PUBLIC_URL + "/09-Gifting.png"} alt="Unfavorable" />
								</div>
								<div className="features-details-card-details-section">
									<h3>Gifting</h3>
									<p>Gift sBTC to Authors</p>
									<p>or</p>
									<p>Other Supported SIP-010 Tokens</p>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</>
	)
}

const ComponentsSection = () => {
	return (
		<div id="componentsSection" className="clients-section">
			<div className="clients-section-bg">
			</div>
			<div className="container clients-section-container">
				<div className="col-md-12 clients-title-block">
					<p className="section-details">Built With</p>
				</div>
				<div className="container clients-list-container">
					<div className="col-lg-2 col-md-4 col-sm-6 col-xs-6 col-12 clients-list">
						<a href="https://stackers.cc" target="_blank" rel="noopener noreferrer" title="CryptoCash"><img src={process.env.PUBLIC_URL + "/cryptocash-logo-256.png"} alt="cryptocash" /></a>
					</div>
					<div className="col-lg-2 col-md-4 col-sm-6 col-xs-6 col-12 clients-list">
						<a href="https://stacks.co" target="_blank" rel="noopener noreferrer" title="Stacks"><img src={process.env.PUBLIC_URL + "/stx-logo-blue-round.png"} alt="stacks" /></a>
					</div>
					<div className="col-lg-2 col-md-4 col-sm-6 col-xs-6 col-12 clients-list">
						{/*eslint-disable-next-line*/}
						<a title="Bitcoin" href="#"><img src={process.env.PUBLIC_URL + "/btc-logo.png"} alt="bitcoin" /></a>
					</div>
				</div>
			</div>
		</div>
	)
}

export default function LandingScreen() {
	const { doOpenAuth } = useConnect();

	const onClick_elButton = async () => {
		doOpenAuth();
	}

	return (
		<div className="landing-page">
			<NavBar connect={onClick_elButton} />
			<div id="top" />
			<div className="wrapper">
				{/* <HeaderSection /> */}
				<FeaturesSection />
				<ComponentsSection />
			</div>
		</div>
	);
}
